
import CommonUtils from '@/common-utils';
import 'swiper/css/swiper.css'
import { Component, Vue } from 'vue-property-decorator'
import TermsPop1 from './TermsPop1.vue';
import TermsPop2 from './TermsPop2.vue';
import TermsPop3 from './TermsPop3.vue';
import TermsPop4 from './TermsPop4.vue';

@Component({
  components: {TermsPop1, TermsPop2, TermsPop3, TermsPop4}
})
export default class SignUp1 extends Vue{
  agrees: Array<boolean> = [false, false, false, false];

  showTerms1 = false;
  showTerms2 = false;
  showTerms3 = false;
  showTerms4 = false;
  
  // computed
  get isAllChecked() {
    return this.agrees.filter( item => item == false ).length == 0;
  }
  
  get getAgrees() {
    return this.agrees;
  }

  // 개별 체크
  toggleChecked(i) {
    this.agrees.splice(i, 1, !this.agrees[i])
  }

  // 전체체크
  toggleAllChecked() {
    const checkStatus = this.isAllChecked;
    this.agrees.forEach((item, idx) => {
      this.agrees.splice(idx, 1, !checkStatus);
    })
  }

  // 다음
  nextStep() {
    if(this.isAllChecked == false) {
      // TODO 개별 체크 약관 성격마다 메시지 변경해줘야 할듯.
      return alert('회원가입 이용약관에 동의해주세요.');
    }

    // PC면 새창
    if(this.$isMobile == false) {
      window.open(`${CommonUtils.createStaticUrl(this, 'SignUp2' )}`, "_blank", "width=762, height=800")
      return;
    } 

    this.$router.push({name: 'SignUp2'})
  }
}
